export const fbConfig = {
    apiKey: "AIzaSyDiwjJPa8qPR8zw7hqbEcjYTDSkE-Lr2fw",
    authDomain: "matera-clock.firebaseapp.com",
    databaseURL: "https://matera-clock.firebaseio.com",
    projectId: "matera-clock",
    redirect_uri: process.env.REDIRECT_URI,
    storageBucket: "matera-clock.appspot.com",
    clientId: process.env.CLIENT_ID,
    messagingSenderId: "610739947031",
    appId: "1:610739947031:web:368096ed3ba8595ab0fe52"
};


export default fbConfig